/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/window.d.ts" />

/**
 * Stream Status service
 */

namespace Application.Services {
    'use strict';
    
    import IHalList = Models.IHalList;
    import ISONDnsMap = Application.Models.ISONDnsMap;
    import SONDnsMap = Application.Models.SONDnsMap;

    /**
     * SonAdapterService
     */
    export class SonAdapterService {
        public static $name: string = "sonAdapterService";
        public static SERVICE_NAME: string = "sonadapter";
        public static $inject: string[] = ['$interval', '$q', '$http', 'backendService', '$rootScope'];


        private $interval: ng.IIntervalService;
        private qService: ng.IQService;
        private http: ng.IHttpService;
        private backendService: Services.BackendService;
        private $rootScope: IFlexRootScope;
        private backendBaseUrl: string = window.backendUrl;
        private servicePath: string = SonAdapterService.SERVICE_NAME;
        private backendUrl: string = this.backendBaseUrl + this.servicePath + '/son';

        constructor($interval: ng.IIntervalService, $q: ng.IQService, $http: ng.IHttpService,
                    backendService: Services.BackendService, $rootScope: IFlexRootScope) {
            this.$interval = $interval;
            this.qService = $q;
            this.http = $http;
            this.backendService = backendService;
            this.$rootScope = $rootScope;
        }

        public getSonServices(showError: boolean = false): ng.IPromise<Models.ISwitch[]> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISwitch[]>();
                d.resolve([]);
                return d.promise;
            }

            return this.backendService
                .get(this.backendUrl + '/services', false, undefined, false, showError)
                .then((result: ng.IHttpPromiseCallbackArg<IHalList<Models.ISwitch>>) => {
                        let convertedData: Models.ISwitch[] = [];
                        $.each(result.data, ((i: number, item: Object) => {
                            let model: Models.ISwitch = new Models.Switch;
                            let dataPathKey: string = 'datapath';
                            let phyPortKey: string = 'phy_port';
                            let labelKey: string = 'label';
                            model.id = item[dataPathKey];
                            model.port = item[phyPortKey];
                            model.name = item[labelKey].replace('Service title:', '');

                            convertedData.push(model);
                        }));

                        return convertedData;
                }).catch((reason: ngCustom.IReason) => {
                    return [];
                });
        }

        public getSonPacketmap(): ng.IPromise<Models.ISonPacketmap> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISonPacketmap>();
                d.resolve(Models.SonPacketmap.Empty());
                return d.promise;
            }

            return this.backendService.get(this.backendUrl + '/packetmap', false, undefined, false, false).then(
                (res: ng.IHttpPromiseCallbackArg<Models.ISonPacketmap>) => {
                    Models.SonPacketmap.burnish(res.data);
                    return res.data;
                });
        }

        public getSonLinkById(id: number): ng.IPromise<Models.ISonLink> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISonLink>();
                d.reject();
                return d.promise;
            }
            return this.backendService.get(this.backendUrl + '/link/' + id).then((res: ng.IHttpPromiseCallbackArg<Models.ISonLink>) => {
                return res.data;
            });
        }

        public getSonSwitchById(id: number): ng.IPromise<Models.ISonNode> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISonNode>();
                d.reject();
                return d.promise;
            }

            return this.backendService.get(this.backendUrl + '/switch/' + id).then((res: ng.IHttpPromiseCallbackArg<Models.ISonNode>) => {
                return res.data;
            });
        }

        public getDNSEntriesByModel(model: string): ng.IPromise<Models.ISONDNSEntry[]> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISONDNSEntry[]>();
                d.resolve([]);
                return d.promise;
            }
            return this.backendService.get(`${this.backendUrl}/v2/dns/searchModel/${model}`)
                .then((res: ng.IHttpPromiseCallbackArg<Models.ISONDNSEntry[]>) => {
                    return res.data;
                });
        }

        public getSourceElementByHostname(hostname: string): ng.IPromise<Models.ISimpleSonElement> {
            const url = `${this.backendUrl}/v2/sources/${hostname}`;
            return this.getSonElement(url);
        }

        public getDestinationElementByHostname(hostname: string): ng.IPromise<Models.ISimpleSonElement> {
            const url = `${this.backendUrl}/v2/destinations/${hostname}`;
            return this.getSonElement(url);
        }

        public getSourceByUid(uid: string): ng.IPromise<Models.ISimpleSonElement> {
            const url = `${this.backendUrl}/v2/sources/byUid/${uid}`;
            return this.getSonElement(url);
        }

        public getDestinationByUid(uid: string): ng.IPromise<Models.ISimpleSonElement> {
            const url = `${this.backendUrl}/v2/destinations/byUid/${uid}`;
            return this.getSonElement(url);
        }

        public async tryGetElementByHostname(hostname: string): Promise<Models.ISimpleSonElement> {  // Try as destination and if not, as source. TODO What is considered a failed request??????
            const destinationElement: Models.ISimpleSonElement = await this.getDestinationElementByHostname(hostname);
            if (destinationElement) {
                return destinationElement;
            }
            const sourceElement: Models.ISimpleSonElement = await this.getSourceElementByHostname(hostname);
            if (sourceElement) {
                return sourceElement;
            }
            return undefined;
        }

        public getAllSonElements(): ng.IPromise<Models.IAllSonElements> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.IAllSonElements>();
                d.resolve(Models.AllSonElements.Empty());
                return d.promise;
            }

            return this.backendService.get(`${this.backendUrl}/v2/elements/`)
                .then((res: ng.IHttpPromiseCallbackArg<Models.IAllSonElements>) => {
                    return res.data;
                });
        }

        public searchSONDNSEntries(fragment: string): ng.IPromise<Models.ISONDNSEntry[]> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISONDNSEntry[]>();
                d.resolve([]);
                return d.promise;
            }

            return this.backendService.get(this.backendUrl + '/v2/dns/search/' + fragment)
            .then((res: ng.IHttpPromiseCallbackArg<Models.ISONDNSEntry[]>) => {
                Models.SONDnsMap.burnish(res.data);
                return res.data;
            });
        }

        public searchSONDNSEntriesByModel(fragment: string, model: string): ng.IPromise<Models.ISONDNSEntry[]> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISONDNSEntry[]>();
                d.resolve([]);
                return d.promise;
            }

            return this.backendService.get(`${this.backendUrl}/v2/dns/searchHostnameModel/${fragment}/${model}`)
                .then((res: ng.IHttpPromiseCallbackArg<Models.ISONDNSEntry[]>) => {
                    Models.SONDnsMap.burnish(res.data);
                    return res.data;
                });
        }


        public searchSONDNSIpRanges(fragment: string): ng.IPromise<Models.ISONDnsMap[]> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISONDnsMap[]>();
                d.resolve([]);
                return d.promise;
            }

            return this.backendService.get(this.backendUrl + '/v2/dns/searchRanges/' + fragment)
                .then((res: ng.IHttpPromiseCallbackArg<Models.ISONDnsMap[]>) => {
                    return res.data.map((sonDnsMap: ISONDnsMap) => SONDnsMap.Copy(sonDnsMap));
                });
        }

        public getSONDnsMap(hostname: string): ng.IPromise<Models.ISONDnsMap> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISONDnsMap>();
                d.resolve(Models.SONDnsMap.Empty());
                return d.promise;
            }

            return this.backendService.get(this.backendUrl + '/v2/dns/hostname/' + hostname)
            .then((res: ng.IHttpPromiseCallbackArg<Models.ISONDnsMap>) => {
                return SONDnsMap.Copy(res.data);
            });
        }

        public getSONIPRangeAddresses(hostname: string): ng.IPromise<string[]> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<string[]>();
                d.resolve([]);
                return d.promise;
            }

            return this.backendService.get(this.backendUrl + '/v2/dns/hostname/' + hostname + '/ips')
                .then((res: ng.IHttpPromiseCallbackArg<string[]>) => {
                    return res.data;
                });
        }

        /**
         * Fetchs a son element
         * @param url backend url for querying the son element
         * @private
         */
        private getSonElement(url: string): ng.IPromise<Models.ISimpleSonElement> {
            if (!this.$rootScope.hasSon) {
                const d = this.qService.defer<Models.ISimpleSonElement>();
                d.resolve(undefined);
                return d.promise;
            }

            return this.backendService.get(url)
                .then((res: ng.IHttpPromiseCallbackArg<Models.ISimpleSonElement>) => {
                    return res.data;
                });
        }
    }
    
}